import { useEffect } from 'react'
import { ModalShell } from './ModalShell'

// Full-resolution image viewer. Built on ModalShell so it shares the app's
// fade/scale-in, backdrop click-to-close, portal, and viewport handling — the
// panel chrome is stripped to transparent so the image floats on the dimmed
// backdrop (a lightbox, not a card). Escape-to-close is added here.
//
// `src` should be the full image URL (NOT the ?s=thumb variant) — the point of
// tapping is to see the photo at full resolution.
export function ImageLightbox({
  open, src, alt = '', onClose,
}: {
  open: boolean
  src: string
  alt?: string
  onClose: () => void
}) {
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { e.preventDefault(); onClose() }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  return (
    <ModalShell
      open={open} onClose={onClose} zIndex={90} backdropPadding={24}
      panelStyle={{
        background: 'transparent', border: 'none', boxShadow: 'none',
        borderRadius: 0, maxWidth: '100%', maxHeight: '100%',
      }}
    >
      {/* Clicking the image itself also closes — the whole surface is dismiss. */}
      <img
        src={src} alt={alt} onClick={onClose}
        style={{
          display: 'block', maxWidth: '90vw', maxHeight: '88dvh',
          width: 'auto', height: 'auto', objectFit: 'contain',
          borderRadius: 8, cursor: 'zoom-out',
          boxShadow: '0 24px 70px rgba(20,14,8,0.45)',
        }}
      />
    </ModalShell>
  )
}
